import PropTypes from 'prop-types';
import React from 'react';
import { Route } from 'react-router-dom';
import BaseUrlContext from '../contexts/BaseUrlContext';
import { Privileged } from '../hocs/withPrivileges';

PrivilegedRoute.propTypes = {
    path: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    component: PropTypes.node,
    render: PropTypes.func,
    children: PropTypes.node,
    exact: PropTypes.bool,
    strict: PropTypes.bool,
    location: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    sensitive: PropTypes.bool,
};

PrivilegedRoute.defaultProps = {
    component: null,
    render: null,
    children: null,
    exact: false,
    strict: false,
    location: null,
    sensitive: false,
};

function PrivilegedRoute(props) {
    const {
        path,
        sufficientPrivileges,
        component,
        render,
        children,
        exact,
        strict,
        location,
        sensitive,
    } = props;
    return (
        <Privileged sufficientPrivileges={sufficientPrivileges}>
            <BaseUrlContext.Provider value={path}>
                <Route
                    path={path}
                    component={component}
                    render={render}
                    children={children} // eslint-disable-line react/no-children-prop
                    exact={exact}
                    strict={strict}
                    location={location}
                    sensitive={sensitive}
                />
            </BaseUrlContext.Provider>
        </Privileged>
    );
}

export default PrivilegedRoute;
